import { cn } from "@punchup/utils/cn";

type PunchupBadgeVariant = "success" | "neutral" | "info" | "danger";

interface PunchupBadgeProps {
  className?: string;
  variant: PunchupBadgeVariant;
  label: string;
}

const VARIANT_CLASSES: Record<PunchupBadgeVariant, string> = {
  success: "bg-green-100 text-green-700",
  info: "bg-blue-50 text-blue-700",
  danger: "bg-red-100 text-red-700",
  neutral: "bg-gray-100 text-gray-600",
};

/**
 * Standard badge component to be used across all surfaces.
 *
 * Add additional variants as needed.
 */
export function PunchupBadge({ variant, className, label }: PunchupBadgeProps) {
  return (
    <span
      className={cn(
        "inline-flex items-center rounded-md px-2.5 py-1 text-xs font-medium",
        VARIANT_CLASSES[variant],
        className
      )}
    >
      {label}
    </span>
  );
}
